var render = function render(){var _vm=this,_c=_vm._self._c;return _c('start-page-template',{attrs:{"compact":""}},[(_vm.isEmailSuccessfullySent)?_c('reset-password-link-sent-message',{on:{"submit":_vm.goToSignInPage}}):_c('forgot-password-form',{attrs:{"loading":_vm.isLoading,"error":_vm.error},on:{"submit-email":_vm.onSendResetLink,"back":_vm.onBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }